module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAASpJREFUWEftV7FqwzAUvAcZ27H+hoKwv8HZu9Z06dahY5cOnZJMGRromg8IFNQO/YP4G2ScqV8QuiVjyQWDA2mUxCHIiIK0Cj2d7nR6J4HnIZ73RwBgM5BOO3F09QrKgwguXEhEYinE2PzMX5B3f7drWgDibPYm4JOLja0aK4zMp3o+DuC2XLg6+S6AioniQ10eBZBkJVs5fV3UaPWHdUuCAKBmoG+0GuxKkWRlD0A1t/f9OGftIQkCAL8MkMxFJLd9zFRE0uoeHLBqv2ntv7GhXwlqqwUb+mOg6SYHF4Re0CoDcVYuAHwVWt27bcezd4I3hW6IZJtQSmAiwPc2CPLcXsBrQO4AjIxuCKVIp50kioYEHgWOYjmwFGBs5ifE8jYD6b7a4WvmnYE1Q55RMDig0AIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/answerSheet.png
// module id = 100
// module chunks = 41